import React, { useEffect, useState } from 'react'
import api from '../components/api'
import { dataTableRender } from '../components/functions'

const CombustaoMovel = (props) => {

    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id
    const [resultado, setResultado] = useState()




    async function carregaDados() {

        await api.get(`GHG_TransporteDistribuicao/${adesao_institucional_id}/${ano}`).then((result) => {

            

            setResultado(result.data.map((rs) =>
            
                <tr>
                    <td><center>{rs.tipoFrota}</center></td>
                    <td><center>{rs.anoFrota}</center></td>
                    <td><center>{rs.distanciaAnual}</center></td>
                    <td><center>{rs.emissoesCO2Fossil}</center></td>
                    <td><center>{rs.emissoesCH4}</center></td>
                    <td><center>{rs.emissoesN2O}</center></td>
                    <td><center>{rs.emissoesTotaisCO2e}</center></td>
                    <td><center>{rs.emissoesCO2Bio}</center></td>
                    

                    
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }



    useEffect(() => {

        carregaDados()

    }, [adesao_institucional_id, ano])



    useEffect(() => {


        //dataTableRender('dataTableExampleClima')


    }, [])


    return (

        <div>

            
                <table id="dataTableExampleClima" className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                          
                            <th style={{ backgroundColor: '#bab6b6'}}> 

                                <center>
                                Tipo Frota
                                </center>

                            </th>
                        
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Ano Frota
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Distância anual
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes CO<sup>2</sup> Fóssil
                                </center>

                            </th>

                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes CH<sup>4</sup>
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes N<sup>2</sup>O
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes Totais CO<sup>2</sup>E
                                </center>

                            </th>
                            <th style={{ backgroundColor: '#bab6b6'}}>
                                <center>
                                Emissoes CO<sup>2</sup> Bio
                                </center>

                            </th>

                            

                            
                        </tr>
                        
                    </thead>
                    <tbody>
                        {resultado}
                    </tbody>
                    
                </table>    



        </div>
    )

}


export default CombustaoMovel